<h2 mat-dialog-title>{{ data.title || 'Upload Document' }}</h2>

<mat-dialog-content>
  <div class="dialog-body" fxLayout="column" fxLayoutGap="12px">
    <mat-form-field>
      <mat-label>Description</mat-label>
      <input matInput [formControl]="descriptionControl" maxlength="255">
    </mat-form-field>

    <mat-form-field *ngIf="allowAssociation">
      <mat-label>Associate with Individual</mat-label>
      <mat-select [formControl]="applicationPersonIdControl">
        <mat-option [value]="null">Application document</mat-option>
        <mat-option *ngFor="let person of people" [value]="person.id">{{ person.firstName }} {{ person.lastName }}</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="file-picker-row" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="8px" fxLayoutAlign="start center">
      <button mat-raised-button color="primary" type="button" (click)="fileInput.click()">
        <mat-icon>attach_file</mat-icon>
        {{ selectedFile ? 'Change File' : 'Choose File' }}
      </button>
      <button *ngIf="selectedFile" mat-button color="warn" type="button" (click)="clearFile()">Remove</button>
      <span class="selected-file-name">{{ selectedFile?.name || 'No file selected' }}</span>
      <input #fileInput type="file" hidden (change)="onFileSelected($event)">
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary" type="button" [disabled]="!selectedFile" (click)="save()">Save</button>
</mat-dialog-actions>
